// src/store/api/baseApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logout, loginSuccess } from '../slices/authSlice';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL || '/api',
  credentials: 'include',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    headers.set('Content-Type', 'application/json');
    return headers;
  },
});

let refreshPromise = null;

const requestUrl = (args) => (typeof args === 'string' ? args : args?.url || '');

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  const url = requestUrl(args);
  const isSessionEndpoint =
    url.includes('/dashboarduser/login') ||
    url.includes('/dashboarduser/register') ||
    url.includes('/dashboarduser/refresh') ||
    url.includes('/dashboarduser/logout');

  if (
    result?.error?.status === 401 &&
    api.getState().auth.token &&
    !isSessionEndpoint
  ) {
    if (!refreshPromise) {
      refreshPromise = baseQuery(
        {
          url: '/dashboarduser/refresh',
          method: 'POST',
          body: {},
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        },
        api,
        extraOptions
      ).finally(() => {
        refreshPromise = null;
      });
    }

    let refreshResult = await refreshPromise;
    if (refreshResult?.error?.status === 409) {
      refreshResult = await baseQuery(
        {
          url: '/dashboarduser/refresh',
          method: 'POST',
          body: {},
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        },
        api,
        extraOptions
      );
    }
    if (refreshResult?.data?.token) {
      api.dispatch(loginSuccess({
        token: refreshResult.data.token,
        user: refreshResult.data.user,
        role: refreshResult.data.role || refreshResult.data.user?.role,
      }));
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logout());
      if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }
  }

  return result;
};

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'Auth', 'Dashboard', 'Products', 'Customers', 'Deposits', 'Withdrawals',
    'Games', 'Users', 'Settings', 'RetentionStats', 'RetentionUsers',
    'CampaignStats', 'PointsStats', 'PointsUsers', 'Conversions',
    'ReconcileSummary', 'ReconcileDeposits',
  ],
  endpoints: () => ({}),
});

export default baseApi;